import React from "react";
import './loader.css';

const Loader = () => {
  return (
    <div className="loaderSystem">
      <div className="spinnerSystem"></div>
    </div>
  );
};

export default Loader;